import React from 'react';
import { Button } from 'antd';
import { Layer } from './BoxLayer';
import { ArrayActionItem, ArrayActions } from '../../hooks/useArrayActions';
import { ItemSchema } from '../../assets';

interface Props {
  items: ArrayActionItem<Layer>[];
  itemArrActions: ArrayActions<Layer>;
  itemSchemas: Record<string, ItemSchema>;
}

export function AddItemButton(props: Props) {
  const { items, itemSchemas, itemArrActions } = props;
  const uniqueItems = React.useMemo(
    () =>
      Object.keys(itemSchemas)
        .filter(schemaId => {
          if (items.find(i => i.item.item === schemaId)) return false;
          return true;
        })
        .map(k => itemSchemas[k])
        .sort((a, b) => a.sortOrder - b.sortOrder),
    [items, itemSchemas]
  );
  const selectRef = React.useRef<HTMLSelectElement | null>(null);
  const onClick = React.useCallback(() => {
    if (!selectRef.current) return;
    const id = selectRef.current.value;
    const schema = itemSchemas[id];
    itemArrActions.prepend({
      item: id,
      colors: schema.colors.map(c => c.color),
    });
  }, [itemArrActions, itemSchemas]);
  if (!uniqueItems.length) return null;
  // TODO: maybe do this via a modal or something once the itemset is huge!
  return (
    <div>
      <select ref={selectRef}>
        {uniqueItems.map(i => (
          <option key={i.id} value={i.id}>
            {i.title}
          </option>
        ))}
      </select>
      <Button type='primary' onClick={onClick}>
        Add
      </Button>
    </div>
  );
}
